var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiflyLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 16,
    viewBox: "0 0 90 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1053_19413)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.1866 6.73151C9.75972 6.68321 9.13959 6.62677 8.49551 6.57042C7.52118 6.48187 6.52252 6.38527 5.87843 6.30477C3.86529 6.04698 3.14856 5.60415 3.15661 4.58948C3.15661 3.96139 3.15661 2.48788 7.99622 2.48788C9.78387 2.48788 11.0159 2.72938 11.7648 3.22866C12.256 3.5588 12.5218 4.00164 12.5862 4.59762L12.6183 4.86327H15.3804L15.3644 4.54932C15.2999 3.32526 14.8651 2.37509 14.0597 1.64226C12.9244 0.627688 10.9998 0.0801034 8.35051 0.00766483C5.45974 -0.0648915 3.34185 0.378055 2.04544 1.32027C1.01467 2.07716 0.475234 3.14012 0.394539 4.57348C0.27389 6.86032 1.95679 8.34208 5.1456 8.75272C5.66109 8.81711 6.41787 8.89761 7.19095 8.97821L7.69023 9.02651C8.58405 9.11506 9.50203 9.21165 10.1141 9.2841C12.4896 9.59009 12.9727 10.3551 12.9727 11.41C12.9727 12.0381 12.9727 13.4956 7.86733 13.4956C3.11636 13.4956 2.96332 11.8852 2.91512 11.3537L2.89097 11.0799H0L0.0160996 11.402C0.0805964 12.6421 0.539534 13.6165 1.43346 14.3734C2.71377 15.4524 4.87996 16 7.86733 16C10.9112 16 13.1096 15.4202 14.406 14.2929C15.5012 13.3507 15.7267 12.2072 15.7267 11.41V11.2972C15.7348 10.1136 15.7509 7.33545 10.1866 6.73151Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8165 0.201172H23.1914V15.7989H25.8165V0.201172Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3651 2.82631H47.566V0.201172H33.6992L35.3544 2.33163C35.5968 2.6438 35.97 2.82631 36.3651 2.82631Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.6232 6.79688H36.3171H36.0192H34.602H34.3039H33.998V15.7996H36.6232V9.42201H47.0753V6.80492H36.6232V6.79688Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.3026 0.201172H54.6855V15.7989H68.0368V13.1818H57.3026V0.201172Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.5572 0.167969C86.0821 0.167969 85.6392 0.385314 85.3412 0.763852L80.9043 6.42474H83.7791C84.2541 6.42474 84.697 6.2074 84.995 5.82886L89.432 0.167969H86.5572Z",
    fill: "#9FA6AD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.123 0.466797L77.3769 11.0478L73.7049 15.7424H77.3124L80.9844 11.0478L72.7306 0.466797H69.123Z",
    fill: "#9FA6AD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1053_19413"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 89.4316,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiflyLogo);
export default __webpack_public_path__ + "static/media/SiflyLogo.59ceb75fed3a978fbb7c4856e45c60ec.svg";
export { ForwardRef as ReactComponent };